module.exports = __webpack_public_path__ + "static/ocLogo-271a25e7537f8d73b5559327dc1f5098.png";